module.exports = __webpack_public_path__ + "img/006.b42de435.jpg";